import script from "./ModalShareSms.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalShareSms.vue?vue&type=script&setup=true&lang=js"

import "./ModalShareSms.vue?vue&type=style&index=0&id=56d96cba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d96cba"]])

export default __exports__